import handleViewport from "react-in-viewport";
import { Container } from "@mantine/core";

const Wrapper = ({
	inViewport,
	forwardedRef,
	children,
	style,
	onEnterViewport,
	onLeaveViewport,
}) => (
	<Container style={{display:'block',...style}} w={"100%"} ref={forwardedRef}>
		{children}
	</Container>
);

const Block = handleViewport(Wrapper);

const ViewportWrapper = ({
	children,
	onEnterViewport,
	onLeaveViewport,
	style,
	className,
	forwardedRef,
}) => {
	return (
		<Block
			forwardedRef={forwardedRef}
			className={className}
			onEnterViewport={onEnterViewport}
			onLeaveViewport={onLeaveViewport}
			style={style}
		>
			{children}
		</Block>
	);
};

export default ViewportWrapper;
